import { provideZoneChangeDetection } from '@angular/core';
import { environment } from '@environment';
import { UserInfo } from '@longnecktech/splash-commons-fe';
import { getTokenParams } from '@shared/utils/get-token-params';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from '@app/app.module';

const { token, instance, gameUuid, language: urlLang } = getTokenParams();

if (token) {
  const selectedLanguage = urlLang || decodeTokenLang(token) || 'en';

  fetch(`${environment.backendUrl}/api/public/auth/token`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept-Language': selectedLanguage,
    },
    body: JSON.stringify({
      token,
      instance,
      gameUuid,
      language: selectedLanguage,
    }),
  })
    .then((response) => response.json())
    .then((data) => {
      (window as Window & typeof globalThis & { user: UserInfo }).user = data;
      platformBrowserDynamic()
        .bootstrapModule(AppModule, {
          applicationProviders: [provideZoneChangeDetection()],
        })
        .catch((err) => console.error(err));
    })
    .catch((error) => console.error('Authentication error:', error));
} else {
  console.warn('No token!');
}

function decodeTokenLang(token: string): string | null {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload?.language ?? null;
  } catch (err) {
    console.warn('Failed to decode JWT', err);
    return null;
  }
}
